/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../lib/schemas.js";
import { Result as SafeParseResult } from "../types/fp.js";
import { SDKValidationError } from "./errors/sdkvalidationerror.js";

export type CountTransactionsResponse = {
  total: number;
};

/** @internal */
export const CountTransactionsResponse$inboundSchema: z.ZodType<
  CountTransactionsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  total: z.number().int(),
});

/** @internal */
export type CountTransactionsResponse$Outbound = {
  total: number;
};

/** @internal */
export const CountTransactionsResponse$outboundSchema: z.ZodType<
  CountTransactionsResponse$Outbound,
  z.ZodTypeDef,
  CountTransactionsResponse
> = z.object({
  total: z.number().int(),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace CountTransactionsResponse$ {
  /** @deprecated use `CountTransactionsResponse$inboundSchema` instead. */
  export const inboundSchema = CountTransactionsResponse$inboundSchema;
  /** @deprecated use `CountTransactionsResponse$outboundSchema` instead. */
  export const outboundSchema = CountTransactionsResponse$outboundSchema;
  /** @deprecated use `CountTransactionsResponse$Outbound` instead. */
  export type Outbound = CountTransactionsResponse$Outbound;
}

export function countTransactionsResponseToJSON(
  countTransactionsResponse: CountTransactionsResponse,
): string {
  return JSON.stringify(
    CountTransactionsResponse$outboundSchema.parse(countTransactionsResponse),
  );
}

export function countTransactionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<CountTransactionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CountTransactionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CountTransactionsResponse' from JSON`,
  );
}
